import { useEffect, useId, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import './dugout-nav.css'
import { DugoutThemePicker } from './DugoutThemePicker'
import { syncPageTheme } from '../../theme/themes'

const links = [
  { label: 'Academy', href: '/learn', section: 'academy' },
  { label: 'Services', href: '/services', section: 'services' },
  { label: 'Work', href: '/portfolio', section: 'work' },
  { label: 'About', href: '/#about', section: 'about' },
]
function HomePlate() {
  return <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2 2 L14 2 L14 9 L8 14 L2 9 Z" fill="currentColor" /></svg>
}
export function DugoutNav() {
  const { pathname, hash } = useLocation()
  const [open, setOpen] = useState(false)
  const menuId = useId()
  const toggle = useRef<HTMLButtonElement>(null)
  useEffect(() => { setOpen(false); syncPageTheme() }, [pathname, hash])
  useEffect(() => {
    if (!open) return
    const close = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { setOpen(false); toggle.current?.focus() }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  }, [open])
  const current = (href: string) => href === '/#about' ? pathname === '/' && hash === '#about' : pathname === href || pathname.startsWith(`${href}/`)
  return <nav className="dugout-nav" aria-label="Dugout navigation" onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false) }}>
    <div className="dugout-nav-inner">
      <a href="/" className="dugout-nav-logo" aria-label="Dugout home"><img src="/site-direction/assets/dugout.png" width="132" height="64" alt="Dugout" /></a>
      <div className="dugout-nav-desktop">
        <a href="/" className="dugout-nav-home" aria-label="Home" aria-current={pathname === '/' && !hash ? 'page' : undefined}><HomePlate /></a>
        {links.map(link => <a key={link.label} className="dugout-nav-link" data-nav-section={link.section} href={link.href} aria-current={current(link.href) ? 'page' : undefined}>{link.label}</a>)}
      </div>
      <div className="dugout-nav-tools"><DugoutThemePicker onOpen={() => setOpen(false)} /><div className="dugout-nav-actions"><a className="dugout-nav-secondary" href="/contact" aria-current={pathname === '/contact' ? 'page' : undefined}>Contact</a><a className="nav-primary" href="/contact">Start a Project <span aria-hidden="true">→</span></a></div>
      <button ref={toggle} className="dugout-nav-toggle" type="button" aria-label={open ? 'Close navigation' : 'Open navigation'} aria-expanded={open} aria-controls={menuId} onClick={() => setOpen(value => !value)}><span aria-hidden="true">{open ? '×' : '☰'}</span></button></div>
    </div>
    <div className="dugout-nav-mobile" id={menuId} hidden={!open}>
      <a className="dugout-nav-home" href="/" onClick={() => setOpen(false)} aria-current={pathname === '/' && !hash ? 'page' : undefined}><HomePlate /><span>Home</span></a>
      {links.map(link => <a key={link.label} className="dugout-nav-link" data-nav-section={link.section} href={link.href} aria-current={current(link.href) ? 'page' : undefined} onClick={() => setOpen(false)}>{link.label}</a>)}
      <a className="dugout-nav-secondary" href="/contact" onClick={() => setOpen(false)}>Contact</a>
      <a className="nav-primary" href="/contact" onClick={() => setOpen(false)}>Start a Project <span aria-hidden="true">→</span></a>
    </div>
  </nav>
}
